import React from "react";

export const ReviewsSkeleton: React.FC = () => {
  return (
    <div className="testimonial-content-details grid xl:grid-cols-[repeat(4,490px)] sm:grid-cols-2 grid-cols-1 gap-x-6 gap-y-14">
      {[...Array(4)].map((_, index) => (
        <div
          key={index}
          className="testimonial-list-2 relative h-full animate-pulse"
        >
          <div className="img-testimonial absolute md:top-[-44px] top-[-28px] left-[32px] md:w-[64px] md:h-[64px] w-[48px] h-[48px] rounded-[100%] overflow-hidden z-[9]">
            <div className="bg-[#1a1a1a] w-full h-full rounded-full" />
          </div>
          <div className="testimonial-review p-[24px] pt-[32px] rounded-[20px] bg-[#0E0E10]">
            <div className="view-message">
              <div className="lg:text-[16px] text-[14px] font-[400] text-white leading-normal lg:pb-5 pb-4">
                <div className="space-y-2">
                  <div className="bg-[#1a1a1a] rounded h-4 w-full" />
                  <div className="bg-[#1a1a1a] rounded h-4 w-5/6" />
                  <div className="bg-[#1a1a1a] rounded h-4 w-4/5" />
                </div>
              </div>
              <span className="divider block bg-[#1a1a1a] h-[1px] my-4" />
              <div className="testimonial-review-detail flex justify-between items-center lg:mt-5 mt-4">
                <div className="name-detail">
                  <div className="bg-[#1a1a1a] rounded h-6 w-32 mb-2" />
                  <div className="bg-[#1a1a1a] rounded h-5 w-24" />
                </div>
                <div className="flex gap-[7px]">
                  {[...Array(5)].map((_, i) => (
                    <div
                      key={i}
                      className="bg-[#1a1a1a] rounded w-4 h-4"
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

